import React from 'react';
import { useSelector } from 'react-redux';
import { useActionDispatcher } from '../../../../hooks';
import { Modal } from '../../../../components';
import yup from '../../../../utility/yup';
import { transferCreditRequest } from '../../../../store/modules/credits/actions';
import { Organization, User } from '../../../../types/items';
import TransferCreditsForm from './TransferCreditsForm';
import { selectTransferCredits } from '../../../../store/modules/credits/selectors';

type Props = {
  user: User;
  open: boolean;
  closeModalHandler: () => void;
};

const TransferCreditsModal = ({ open, closeModalHandler, user }: Props) => {
  const { loading } = useSelector(selectTransferCredits);
  const initialData = {
    video_credits_qty: 1,
    note: '',
    transfer_from_user_id: user.id,
    transfer_to_user_id: 0,
    transfer_from_organization_id: user.organization_id,
    transfer_to_organization_id: user.organization_id,
  };

  const schema = yup.object().shape({
    transfer_from_user_id: yup.number().required(),
    transfer_to_user_id: yup.number().required(),
    note: yup.string().trim(),
    video_credits_qty: yup.number().min(1).required().label('Credit Quantity'),
  });

  return (
    <Modal
      form={{
        data: initialData,
        validationSchema: schema,
        onSubmit: useActionDispatcher(transferCreditRequest),
        submitTitle: 'Transfer',
        loading,
      }}
      open={open}
      onCloseHandler={() => closeModalHandler()}
      title="Transfer Credits"
      hideCancel
    >
      <TransferCreditsForm
        userFromId={user.id}
        organization={user.ref.organization as Organization}

      />
    </Modal>
  );
};

export default TransferCreditsModal;
